import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FonctionnelService {
  module = environment.webService.server + environment.webService.url + environment.webService.api;
  constructor(private http: HttpClient) {}

  getAllServicesDemandes() {
    return this.http.get<any>(this.module + '/services-fonctionnels/all');
  }
  getServicesDemandesByDirection(id_direction: any) {
    return this.http.get<any>(this.module + '/services-fonctionnels/by-direction/' + id_direction);
  }

  getMyServicesByDirection(id_direction: string) {
    return this.http.get<any>(this.module + '/services-fonctionnels/mes/by-direction/' + id_direction);
  }

  // getServicesDemandesByDirection(id_direction: any) {
  //   return this.http.get<any>(this.module + '/services-fonctionnels/by-direction/' + id_direction).pipe(
  //     map(() => [
  //       {
  //         id: '0c018c0a-23df-4ddd-a6eb-73a90f329a0c',
  //         libelle: 'Studia',
  //         direction: {
  //           id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  //           libelle: 'Studia',
  //           structValidation: 'string',
  //           createdBy: 'string',
  //           lastModifiedBy: 'string',
  //           lastModifiedAt: '2024-12-23T11:01:54.296Z',
  //           pole: {
  //             id: '0c018c0a-23df-4ddd-a6eb-73a90f329a0c',
  //             code: 'string',
  //             libelle: 'Studia'
  //           },
  //           lastModifiedDate: '2024-12-23T11:01:54.296Z',
  //           createdDate: '2024-12-23T11:01:54.296Z'
  //         }
  //       }
  //     ])
  //   );
  // }
}
